//import { forEach } from "@angular/router/src/utils/collection";
import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  NgZone,
  ElementRef,
  VERSION,
  Inject,
  Input
} from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Subject } from "rxjs";
import { HttpClientModule } from "@angular/common/http";
import { DataTableDirective } from "angular-datatables";
import { DOCUMENT } from '@angular/common';
import { logbaseService } from "../../services/logbase.service";
import { dataService } from "../../services/data.service";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { map } from 'rxjs/operators';
import "chart.js";
import "chart.piecelabel.js";
import { TranslateService } from "@ngx-translate/core";
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';

@Component({
  selector: "app-usermanagement",
  templateUrl: "./usermanagement.component.html",
  styleUrls: ["./usermanagement.component.scss"]
})
export class UsermanagementComponent implements OnInit {
  userStatus: any;
  public pieChartColors: any[];
  public dataChart: any[];
  public labels: Array<string>;
  public pieChartType: string = "doughnut";
  usersNeverLogged: any;
  userLoggedInCount: any;
  usersLoggedInLast31Days: any;
  currentlyLoggedInUsers: any;
  userData: any;
  userIndividualCount: any;
  allRodeIds: any;
  NofSupplier: any;
  eachUsers: any;
  userCount: any;
  users: any;
  @ViewChild(DataTableDirective)
  userSelected: any;
  todayDate: any;
  rowsPerPage: any;
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  message = "";
  totalRecords:any='';
  emptySearchValue;
  usersListOpt = [
    "Supplier",
    "SMQ",
    "Logistic",
    "Operation",
    "Admin",
    "SMVS",
    "SM Admin",
    "Logistic Admin",
    "Assembly Operator",
    // "Line Worker",
    "Level-4 Manager",
    "LSP"
  ];

  roleType: any;
  searchValue: any;
  searchValueColumn: any = "select";
  searchValuePlaceholder: any = "Search All Columns";
  searchValueList: any = [
    { label: "Select", value: "select" },
    { label: "User Name", value: "userName" },
    { label: "Role", value: "role" },
    // { label: "Supplier Code", value: "supplierCode" },
    { label: "First Name", value: "firstName" },
    { label: "Last Name", value: "lastName" },
    { label: "Company Name", value: "companyName" },
    { label: "Email address", value: "email" },
    { label: "Phone Number", value: "phoneNumber" },
    { label: "Status", value: "status" }
  ];

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any,
    private logbaseService: logbaseService,
    private router: Router,
    private dataService: dataService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) { 
    this.chartOptions= {
      pieceLabel: {
        render: "value",
        fontColor: "#fff",
        fontStyle: "bold",
        precision: 0,
        position: "border"
        // labels: {
        //   render: 'value',
        //   fontColor: '#fff',
        //   fontStyle: 'bold',
        //   precision: 0,
        //   position: "border"
        // }
      },
      legend: {
        position: "left"
      },
      title: {
        display: true,
        text: this.translate.instant("Individual User Count"),
        fontSize: 20
      },
      animation: {
        animateScale: true,
        animateRotate: true
      }
  };
  }

  ngOnInit(): void {
    this.rowsPerPage = 10;
    var pageData = {
      pageNum: 0,
      pageSize: 10,
      searchValueColumn: null
    };

    localStorage.removeItem("cacheUser");
    this.spinner.show();
    this.logbaseService.getUserDetailsPaginated(pageData).subscribe(result => {
      this.users = result.response.content;
      this.users.forEach(element => {
        this.userStatus = element.status;
        if (this.userStatus == "In Active") {
          element["userStatus"] = "Inactive";
        } else {
          element["userStatus"] = "Active";
        }
      });

      this.totalRecords = result.response.totalElements;

      this.roleType = [
        { label: "Supplier", value: "Supplier" },
        { label: "SMQ", value: "SMQ" },
        { label: "SMVS", value: "SMVS" },
        { label: "Logistic", value: "Logistic" },
        { label: "Operation", value: "Operation" },
        { label: "SM Admin", value: "SM Admin" },
        { label: "Logistic Admin", value: "Logistic Admin" },
        { label: "Assembly Operator", value: "Assembly Operator" },
        { label: "Level-4 Manager", value: "Level-4 Manager" },
        { label: "LSP", value: "LSP" },
        { label: "Admin", value: "Admin" }
      ];

      this.userCount = this.users.length;
      this.users.forEach(element => {
        element["roleName"] = element.userRoleMappings.roleName;
      });
      localStorage.setItem("usersData", JSON.stringify(this.users));
      // set data in service which is to be shared
      this.dataService.setpartAPIData(result.response.content);
      this.spinner.hide();
      var suppCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 1;
      });
      var SMQCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 2;
      });
      var SMVSCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 7;
      });
      var SMadminCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 8;
      });
      var logCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 3;
      });
      var operationsCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 4;
      });
      var SMadminCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 8;
      });
      var LogAdminCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 9;
      });
      var adminCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 5;
      });
      var assemblyOperatorCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 10;
      });
      // var lineWorkerCount = this.users.filter(function (user) {
      //   return user.userRoleMappings[0].roleId == 11;
      // });
      var L4ManagerCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 12;
      });
      var LSPCount = this.users.filter(function (user) {
        return user.userRoleMappings.roleId == 13;
      });
      this.dataChart = [
        {
          data: [
            suppCount.length,
            SMQCount.length,
            SMVSCount.length,
            logCount.length,
            operationsCount.length,
            SMadminCount.length,
            LogAdminCount.length,
            adminCount.length,
            assemblyOperatorCount.length,
            // lineWorkerCount.length,
            L4ManagerCount.length,
            LSPCount.length
          ],
          borderWidth: 0
        }
      ];
      (this.labels = [
        "Supplier",
        "SMQ",
        "SMVS",
        "Logistics",
        "Operations",
        "SM Admin",
        "Logistic Admin",
        "Admin",
        "Assembly Operator",
        // 'Line Worker',
        "L4 Manager",
        "LSP"
      ]),
        (this.pieChartColors = [
          {
            backgroundColor: [
              "#003340",
              "#00677f",
              "#007a93",
              "#79aebf",
              "#e69123",
              "#eba550",
              "#f0be7d",
              "#6ea046",
              "#aac891",
              "#e1ebdc",
              "#72170c",
              "#c8a0a0"
            ]
          }
        ]);
      this.logbaseService.getUserStatisticsData().subscribe(result => {
        this.userData = result;
        this.spinner.hide();
        this.usersNeverLogged = this.userData.response.USERNEVERLOGINCOUNT;
        this.userLoggedInCount = this.userData.response.USERLOGINEDINCOUNT;
        this.usersLoggedInLast31Days = this.userData.response.LAST31DAYSUSERLOGINEDINCOUNT;
        this.currentlyLoggedInUsers = this.userData.response.USERCURRENTLYLOGINEDINCOUNT;
      });
    });
  }
  public downloadCSV() {
    this.spinner.show();

    let newExportData = [];
    let completeusers = [];

    this.logbaseService.getUserForCSV().subscribe(result => {
      let reslutData: any = result;
      completeusers = reslutData.response;
      completeusers.forEach(element => {
        let obj = {};
        obj["User Name"] = element.userName;
        let userRoles = "";
        let userRoleRaw = [];
        userRoleRaw = element.userRoles;
        if (null != userRoleRaw && userRoleRaw.length > 0)
          userRoles = userRoleRaw.toString();
        obj["Roles"] = userRoles;
        let supplierCodes = "";
        let supplierCodeRaw = [];
        supplierCodeRaw = element.supplierCodes;
        if (null != supplierCodeRaw && supplierCodeRaw.length > 0)
          supplierCodes = supplierCodeRaw.toString();
        obj["First Name"] = element.firstName;
        obj["Last Name"] = element.lastName;
        obj["Company Name"] = element.companyName;
        obj["Email Id"] = element.emailId;
        obj["Phone Number"] = element.phone != null ? element.phone : "";
        obj["Status"] = element.status;
        obj["Supplier Codes"] = supplierCodes;
        newExportData.push(obj);
      });
      var options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalseparator: ".",
        showLabels: true,
        showTitle: false,
        headers: [
          "LoginId",
          "Roles",
          "First Name",
          "Last Name",
          "Company Name",
          "Email Id",
          "Phone Number",
          "Status",
          "Supplier Codes"
        ]
      };
      new AngularCsv(newExportData, "User Master", options);
      this.spinner.hide();
    });
  }

  public chartOptions: any 

  getCellData(row) {
    let supCodes = row.supplierCode.map(sc => sc.supplierCode);
    return supCodes;
  }

  getCellDataRoles(row) {
    let rolesData = row.userRoleMappings.map(role => role.userRole.roleName);
    return rolesData;
  }

  setPlaceHolder(event) {
    const label = this.searchValueList.filter(val => event === val.value)[0]
      .label;
    this.searchValuePlaceholder =
      event !== "select" ? `Search for ${label}` : "Search All Columns";
  }

  onEnter(event) {
    if (event.keyCode == 13) {
      this.nextPage(event);
    }
  }

  nextPage(event) {

    this.spinner.show();
    if (event.keyCode !== 13) {
      this.rowsPerPage = event.rows;
    }
    if (event.rows == undefined || event.rows == null) pagenumbercal = 0;
    else var pagenumbercal = event.first / event.rows;
    // var pageData = {
    //   pageNum: pagenumbercal,
    //   pageSize: this.rowsPerPage,
    //   sortField: event.sortField,
    //   sortOrder: event.sortOrder,
    //   searchValue: event.globalFilter
    // };



    var newPageData = {
      pageNum: pagenumbercal,
      pageSize: this.rowsPerPage,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
      searchValueColumn: this.searchValueColumn === 'select' ? null : this.searchValueColumn,
      searchValue: this.searchValue
    };

   
  
    this.emptySearchValue = null;

    // if (
    //   newPageData.searchValue == "" ||
    //   newPageData.searchValue == undefined ||
    //   newPageData.searchValue == null
    // ) {
    //   newPageData.searchValue = this.searchValue;
    // }
 
    this.logbaseService.getUserDetailsPaginated(newPageData).subscribe(result => {
       this.totalRecords=result.response.totalElements
      this.users = result.response.content;
      this.users.forEach(element => {  
        this.userStatus = element.status;
        if (this.userStatus == "In Active") {
          element["userStatus"] = "Inactive";
        } else {
          element["userStatus"] = "Active";
        }
      });
      this.roleType = [
        { label: "Supplier", value: "Supplier" },
        { label: "SMQ", value: "SMQ" },
        { label: "SMVS", value: "SMVS" },
        { label: "Logistic", value: "Logistic" },
        { label: "Operation", value: "Operation" },
        { label: "SM Admin", value: "SM Admin" },
        { label: "Logistic Admin", value: "Logistic Admin" },
        { label: "Assembly Operator", value: "Assembly Operator" },
        { label: "Level-4 Manager", value: "Level-4 Manager" },
        { label: "LSP", value: "LSP" },
        { label: "Admin", value: "Admin" }
      ];

      //this.userCount = this.users.length;
      this.users.forEach(element => {
        element["roleName"] = element.userRoleMappings.roleName;
      });
      // localStorage.setItem('usersData', JSON.stringify(this.users));
      // set data in service which is to be shared
      //this.dataService.setpartAPIData(result.response.content);
      this.spinner.hide();
    });
  }
  rowEdit(data) {
    this.spinner.show();
    this.router.navigate([
      "/account",
      data.userName,
      data.userRoleMappings[0].userRole.roleId
    ]);
    this.spinner.hide();
  }

  ngAfterViewInit(): void { }

  private extractData(res: HttpResponse<any>) {
    const body = res.body.json();
    return body.data || {};
  }
}
